module.exports = __webpack_public_path__ + "img/arrow-up-from-bracket-solid.8a7f6fde.svg";